module.exports = __webpack_public_path__ + "static/media/logo-medium.0244fee2.gif";